// extracted by mini-css-extract-plugin
export default {"seeFullDetailsButton":"DescriptionCellRenderer_seeFullDetailsButton__93G7M"};